'use strict';

import api from '../../api';

export default {
  namespaced: true,
  state: {
    comments: []
  },
  actions: {
    clear({commit}) {
      commit('clear');
    },
    getNew({commit, state}, poolId) {
      let params = {pool_id: poolId};
      if (state.comments.length) {
        params.after_id = state.comments[0].id;
      }
      return api.Comment.index({params})
        .then(comments => commit('prepend', comments));
    },
    getMore({commit, state}, poolId) {
      let params = {pool_id: poolId, limit: 20};
      if (state.comments.length) {
        params.before_id = state.comments[state.comments.length - 1].id;
      }
      return api.Comment.index({params})
        .then(comments => commit('append', comments));
    },
    create({dispatch}, comment) {
      return api.Comment.create({params: {pool_id: comment.pool_id, comment}})
        .then(() => dispatch('getNew', comment.pool_id));
    },
    destroy({commit}, {comment, poolId}) {
      return api.Comment.destroy({params: {comment, pool_id: poolId}})
        .then(() => commit('remove', comment));
    }
  },
  mutations: {
    clear(state) {
      state.comments = [];
    },
    append(state, comments) {
      state.comments = [...state.comments, ...comments];
    },
    prepend(state, comments) {
      state.comments = [...comments, ...state.comments];
    },
    remove(state, comment) {
      state.comments = state.comments.filter(comm => comm.id != comment.id);
    }
  },
  getters: {
    comments: state => {
      return state.comments;
    }
  }
};
